import axios from "axios";

import { IP } from "utils/Host";

export function ustawPrzyczytane(
  targetId,
  nowa,
  proces_nazwa_id,
  refreshGantAll,
) {
  axios
    .put(IP + "API_0021_zadanie_przeczytane/" + sessionStorage.getItem("token"), {
      targetId,
      nowa,
      oprawa: proces_nazwa_id,
    })
    .then((res) => {
      refreshGantAll();
    });
}
